import "../../style/reaching.css";

const Location = () => {
  return (
    <>
      <div className="about ms-md-4 ms-lg-5">Location</div>
      <div className="border-bottom ms-md-4 ms-lg-5"></div>
      <div className="text1 mx-auto ms-md-4 ms-lg-5">
        The University is located on Gorakhpur-Deoria road, about 9 kilometres
        from Gorakhpur Railway Station as well as from main Gorakhpur Roadways
        bus-station.
      </div>
    </>
  );
};

export default Location;
